import React from 'react'
import { Hide } from 'pcln-design-system'
import { type Booking } from '@/components/CrossSell/types'
import useExtendStayBooking, {
  type ExtendStayBooking
} from '@/hooks/useExtendStayBooking'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import ExtendStay from '@/components/ExtendStay'
import CrossSell from '@/components/CrossSell'
import TripActivityModule from '../TripActivityModule'

function UpcomingTrip({
  mostRecentFutureBooking,
  extendData
}: {
  mostRecentFutureBooking?: Booking | null
  extendData: ExtendStayBooking | null
}) {
  return (
    (extendData || mostRecentFutureBooking) && (
      <Hide md mb={4}>
        {extendData ? (
          <ExtendStay {...extendData} />
        ) : (
          mostRecentFutureBooking && (
            <CrossSell booking={mostRecentFutureBooking} />
          )
        )}
      </Hide>
    )
  )
}

export default function TripDisplayOrder() {
  const { mostRecentFutureBooking } = useMostRecentFutureBooking()
  const extendData = useExtendStayBooking()

  const shouldUseSmallerHeading = Boolean(mostRecentFutureBooking || extendData)

  return (
    <>
      <UpcomingTrip
        extendData={extendData}
        mostRecentFutureBooking={mostRecentFutureBooking}
      />
      <TripActivityModule shouldUseSmallerHeading={shouldUseSmallerHeading} />
    </>
  )
}
